/* Filter sheet for collection and search pages on screens up to 1100px. Filters still submit on change (theme.js). */
(() => {
  const sheet = document.querySelector('[data-filter-sheet]');
  if (!sheet || sheet.dataset.ready) return;
  sheet.dataset.ready = '1';
  const toggles = [...document.querySelectorAll('[data-filter-sheet-open]')];
  let opener = null;
  const close = () => {
    if (!sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('filter-sheet-open');
    sheet.removeAttribute('role'); sheet.removeAttribute('aria-modal'); sheet.removeAttribute('aria-label');
    toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
    opener?.focus();
  };
  const open = trigger => {
    opener = trigger;
    sheet.classList.add('is-open');
    document.documentElement.classList.add('filter-sheet-open');
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', sheet.querySelector('.filters__head h2')?.textContent.trim() || 'Filters');
    toggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
    sheet.querySelector('[data-filter-sheet-close]')?.focus();
  };
  toggles.forEach(t => t.addEventListener('click', () => open(t)));
  sheet.querySelectorAll('[data-filter-sheet-close]').forEach(b => b.addEventListener('click', close));
  sheet.addEventListener('keydown', e => {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || !sheet.classList.contains('is-open')) return;
    const items = [...sheet.querySelectorAll('a[href], button, input, select, summary')].filter(el => el.offsetParent !== null && !el.disabled);
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  matchMedia('(min-width: 1101px)').addEventListener('change', e => { if (e.matches) close(); });
})();
